import React from 'react'
import { MakeRequestModel } from '../requestsModel'
import { SignResponseModel } from '../../profile/profileModel'


export const request: Partial<MakeRequestModel> = {
	contract: null,
	propertyConcerned: '',
	residence: '',
	interlocutor: '',
	requestType: '',
	requestPurpose: '',
	requestConcern: ''
}

export const MakeRequestContext = React.createContext({
		request: request, // Data filled step by step
		step: 1,
		setStep: (step: number) => {},
		previousStep: () => {
		},
		nextStep: (signResponse?: SignResponseModel) => {
		},
		closeDialog: () => {
		},
		resetStep: () => {
		}
	}
)
